/* archive-filters.js — AJAX filter UI for main-collection-archive v3 */
(function () {
  'use strict';

  const layout       = document.getElementById('js-archive-layout');
  const filterPanel  = document.getElementById('js-filter-panel');
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const sortSelect   = document.querySelector('[data-sort-select]');
  const filterForm   = document.getElementById('onbond-filters');
  const searchInput  = document.querySelector('[data-archive-search]');

  if (!layout) return;

  let currentSystem = 'us';
  let selectedType  = '';
  let rawSizes      = [];

  /* ── Helpers ─────────────────────────────────────────────────────────────── */
  function readRawSizes() {
    const el = document.getElementById('js-size-raw-data');
    if (!el) return;
    try { rawSizes = JSON.parse(el.textContent); } catch { rawSizes = []; }
  }

  function getSizeGrid()   { return document.querySelector('[data-size-grid]'); }
  function getSizeToggle() { return document.querySelector('[data-size-toggle]'); }

  function getSystemLabel(category, system) {
    if (category === 'footwear') return system === 'eu' ? 'EU' : 'US';
    if (category === 'bottoms')  return system === 'jp' ? 'JP' : 'US';
    return system === 'jp' ? 'JP' : 'US / EU';
  }

  function shouldShowSize(type) {
    if (!type) return false;
    return !/^(accessories|accessory)/i.test(type.trim());
  }

  function sizeToolsUrl() {
    return document.querySelector('[data-size-tools-url]')?.dataset.sizeToolsUrl || '';
  }

  /* ── Filter panel toggle ─────────────────────────────────────────────────── */
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', () => {
      filterPanel.classList.toggle('is-open');
      filterToggle.classList.toggle('is-active');
      layout.classList.toggle('has-filters', filterPanel.classList.contains('is-open'));
    });
  }

  /* ── Sort select ─────────────────────────────────────────────────────────── */
  if (sortSelect) {
    sortSelect.addEventListener('change', () => applyFilters());
  }

  /* ── Filter form change ──────────────────────────────────────────────────── */
  if (filterForm) {
    filterForm.addEventListener('change', (e) => {
      if (e.target.dataset.expandToggle !== undefined) return; // vendor expand toggle, not a filter
      if (e.target.dataset.typeRadio !== undefined) {
        selectedType = e.target.value;
        updateSizeVisibility();
        updateSizeToggle(); // async — also calls renderSizeChips when done
        applyFilters(true); // clear size params when type changes
      } else {
        applyFilters();
      }
    });
  }

  /* ── Filter panel clicks — size toggle + type radio deselect ────────────── */
  let _typeWasChecked = false;

  if (filterPanel) {
    /* Record pre-click state so we can detect a re-click on an active radio */
    filterPanel.addEventListener('pointerdown', (e) => {
      const r = e.target.closest('[data-type-radio]');
      _typeWasChecked = r ? r.checked : false;
    });

    filterPanel.addEventListener('click', (e) => {
      /* Deselect type radio when clicking the already-active one */
      const r = e.target.closest('[data-type-radio]');
      if (r && _typeWasChecked) {
        r.checked = false;
        selectedType = '';
        updateSizeVisibility();
        updateSizeToggle();
        applyFilters(true);
        return;
      }

      /* Size system toggle */
      const sysBtn = e.target.closest('[data-size-toggle] [data-system]');
      if (!sysBtn) return;
      const toggle = sysBtn.closest('[data-size-toggle]');
      toggle.querySelectorAll('button').forEach(b => b.classList.remove('is-active'));
      sysBtn.classList.add('is-active');
      currentSystem = sysBtn.dataset.system;
      renderSizeChips();
    });
  }

  /* ── Clear filters link — AJAX interception ─────────────────────────────── */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('#js-filter-clear a');
    if (!btn) return;
    e.preventDefault();
    const clearUrl = new URL(btn.href);
    clearUrl.searchParams.set('filter.p.available', '1');
    if (sortSelect) clearUrl.searchParams.set('sort_by', sortSelect.value);
    fetchAndUpdate(clearUrl.pathname + '?' + clearUrl.searchParams.toString(), true);
  });

  /* ── SIZE visibility ────────────────────────────────────────────────────── */
  function updateSizeVisibility() {
    const fieldset = document.querySelector('[data-filter="size"]');
    if (!fieldset) return;
    fieldset.classList.toggle('is-visible', shouldShowSize(selectedType));
  }

  /* ── SIZE toggle rebuild ────────────────────────────────────────────────── */
  function updateSizeToggle() {
    const toggle = getSizeToggle();
    const url    = sizeToolsUrl();
    if (!toggle || !url) return;

    import(url)
      .then(({ categorizeProductType, availableSystems }) => {
        const cat     = categorizeProductType(selectedType);
        const systems = availableSystems(cat);
        toggle.innerHTML = '';
        systems.forEach((sys, i) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.dataset.system = sys;
          if (i === 0) {
            btn.classList.add('is-active');
            currentSystem = sys;
          }
          btn.textContent = getSystemLabel(cat, sys);
          toggle.appendChild(btn);
        });
        renderSizeChips();
      })
      .catch(() => {});
  }

  /* ── Render size chips ───────────────────────────────────────────────────── */
  function renderSizeChips() {
    const sizeGrid = getSizeGrid();
    const url      = sizeToolsUrl();
    if (!sizeGrid || !url) return;
    sizeGrid.innerHTML = '';

    import(url)
      .then(({ categorizeProductType, canonicalSizes, expandFilterSize }) => {
        const cat      = categorizeProductType(selectedType);
        const canonical = canonicalSizes(cat, currentSystem);

        canonical.forEach(size => {
          const expanded = expandFilterSize(cat, size, currentSystem);
          const matching = rawSizes.filter(rv =>
            expanded.some(e =>
              e.toLowerCase() === rv.label.toLowerCase() ||
              e.toLowerCase() === rv.label.replace(/["'wW\s]/g, '').toLowerCase()
            )
          );
          const hasStock  = matching.some(rv => rv.count > 0);
          const isActive  = matching.some(rv => rv.active);
          const addUrl    = matching.find(rv => rv.addUrl)?.addUrl || '';
          const removeUrl = matching.find(rv => rv.removeUrl)?.removeUrl || '';

          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'label-mono onbond-chip' + (isActive ? ' is-active' : '');
          chip.textContent = size;
          chip.style.opacity = hasStock ? '1' : '0.4';

          chip.addEventListener('click', () => {
            const dest = isActive ? removeUrl : addUrl;
            if (dest) fetchAndUpdate(dest);
          });

          sizeGrid.appendChild(chip);
        });
      })
      .catch(() => {
        /* Fallback: render raw sizes as-is */
        rawSizes.forEach(rv => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'label-mono onbond-chip' + (rv.active ? ' is-active' : '');
          chip.textContent = rv.label;
          chip.style.opacity = rv.count > 0 ? '1' : '0.4';
          chip.addEventListener('click', () => {
            const dest = rv.active ? rv.removeUrl : rv.addUrl;
            if (dest) fetchAndUpdate(dest);
          });
          sizeGrid.appendChild(chip);
        });
      });
  }

  /* ── AJAX fetch and update ──────────────────────────────────────────────── */
  function fetchAndUpdate(url, updateForm = false) {
    history.pushState({}, '', url);

    const curGrid = document.getElementById('js-product-grid');
    if (curGrid) curGrid.style.opacity = '0.5';

    fetch(url)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        /* Product grid */
        const newGrid = doc.getElementById('js-product-grid');
        if (newGrid && curGrid) {
          curGrid.style.opacity = '';
          curGrid.innerHTML = newGrid.innerHTML;
        }

        /* Results count */
        const newCount = doc.querySelector('.onbond-archive__count');
        const curCount = document.querySelector('.onbond-archive__count');
        if (newCount && curCount) curCount.textContent = newCount.textContent;

        /* Clear filters link */
        const newClear = doc.getElementById('js-filter-clear');
        const curClear = document.getElementById('js-filter-clear');
        if (newClear) {
          if (curClear) {
            curClear.outerHTML = newClear.outerHTML;
          } else {
            const sizeDataEl = document.getElementById('js-size-raw-data');
            if (sizeDataEl) sizeDataEl.insertAdjacentHTML('beforebegin', newClear.outerHTML);
          }
        } else if (curClear) {
          curClear.remove();
        }

        /* Filter toggle badge */
        const newBadge = doc.querySelector('[data-filter-toggle] .onbond-filter-count');
        const curBadge = filterToggle?.querySelector('.onbond-filter-count');
        if (curBadge) curBadge.remove();
        if (newBadge && filterToggle) {
          const caret = filterToggle.querySelector('.onbond-filter-caret');
          if (caret) caret.insertAdjacentHTML('beforebegin', newBadge.outerHTML);
        }

        /* Replace filter form (needed when an active chip removes a filter) */
        if (updateForm && filterForm) {
          const newForm = doc.getElementById('onbond-filters');
          if (newForm) {
            filterForm.innerHTML = newForm.innerHTML;
            const checkedRadio = filterForm.querySelector('[data-type-radio]:checked');
            selectedType = checkedRadio ? checkedRadio.value : '';
            updateSizeVisibility();
            updateSizeToggle(); // async — also calls renderSizeChips
          }
        }

        /* Raw size data */
        const newSizeData = doc.getElementById('js-size-raw-data');
        const curSizeData = document.getElementById('js-size-raw-data');
        if (newSizeData && curSizeData) curSizeData.textContent = newSizeData.textContent;
        readRawSizes();

        /* Re-render chips unless updateSizeToggle will do it asynchronously */
        if (!updateForm) renderSizeChips();
      })
      .catch(() => {
        if (curGrid) curGrid.style.opacity = '';
        window.location.href = url;
      });
  }

  /* ── Apply filters (build URL from form state) ───────────────────────────── */
  function applyFilters(clearSizes = false) {
    if (!filterForm) return;
    const params = new URLSearchParams();
    params.set('filter.p.available', '1');

    filterForm.querySelectorAll('[data-filter-input]:checked').forEach(inp => {
      params.append(inp.name, inp.value);
    });
    filterForm.querySelectorAll('[data-filter-input][type="number"]').forEach(inp => {
      if (inp.value !== '') params.set(inp.name, inp.value);
    });

    /* Preserve active size params across other filter changes */
    if (!clearSizes) {
      new URLSearchParams(window.location.search).forEach((val, key) => {
        if (key.toLowerCase().includes('option.size')) params.append(key, val);
      });
    }

    if (sortSelect) params.set('sort_by', sortSelect.value);

    fetchAndUpdate(window.location.pathname + '?' + params.toString());
  }

  /* ── Search ──────────────────────────────────────────────────────────────── */
  if (searchInput) {
    let searchTimer;
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        const q = searchInput.value.trim();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      }, 600);
    });
  }

  /* ── Initial state ───────────────────────────────────────────────────────── */
  readRawSizes();
  const initTypeRadio = document.querySelector('[data-type-radio]:checked');
  if (initTypeRadio) selectedType = initTypeRadio.value;
  updateSizeVisibility();
  if (selectedType) {
    updateSizeToggle(); // also calls renderSizeChips when resolved
  } else {
    renderSizeChips();
  }

})();
